let userLoggedIn = false;

export const setUserLoggedIn = (loggedIn: boolean): void => {
  userLoggedIn = loggedIn;
};

export const getUserLoggedIn = (): boolean => {
  return userLoggedIn;
};
